import { Link } from "react-router";
import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";
import { PageScaffold } from "../shell/PageScaffold";

/**
 * The 403 screen the advisory guard renders in place of a screen the caller's role does not reach.
 * It offers a "switch venue" way out — the same role can be higher at a different venue (R1). No
 * permission decision is made here beyond rendering; the server is authoritative at action time.
 */
export function Forbidden() {
  const { t } = useTranslation();
  return (
    <PageScaffold title={t("shell.forbidden.title")}>
      <p className={css({ color: "fg.muted" })}>{t("shell.forbidden.subtitle")}</p>
      <Link
        to="/select-venue"
        className={css({ color: "accent.default", textDecoration: "underline" })}
      >
        {t("shell.forbidden.switchVenue")}
      </Link>
    </PageScaffold>
  );
}
